module.exports = __webpack_public_path__ + "static/media/thumb_conceptcube_503x503.b0c88a11.jpg";